import React from "react";

export function RestlessInteractionsFormatter(cellContent) {
  return (
    <div>
      {cellContent === undefined || cellContent === null ? 0 : cellContent}
    </div>
  );
}
